import "../css/addEvent.css";

import React, {useState} from "react";
import { useLanguage } from "../components/Language.js";


function EventForm({events, fetchEvents, retrieveLatLong, onClose}) {

    var current_date = new Date();
    const {language} = useLanguage();

    const translations = {
        en: {
            endTimeBefore: "End time is before start time",
            startTimePassed: "Start time has passed",
            endDateBefore: "End date is before start date.",
            startDatePast: "Start date is in the past",
            invalidPostcodeEntered: "Invalid postcode entered",
            yourFormCannotBeSubmitted: "Your form cannot be submitted:",
            addAnEvent: "Add an Event",
            eventTitle: "Event Title",
            eventDescription: "Event Description (If tickets are required, please link to where tickets can be obtained)",
            eventStartTime: "Event Start Time",
            eventEndTime: "Event End Time",
            eventStartDate: "Event Start Date",
            eventEndDate: "Event End Date",
            eventPostcode: "Event Postcode",
            uploadImage: "Upload Image",
            eventProficiencyLevel: "Event Proficiency Level",
            createEvent: "Create Event", 
            startTime: "Start Time: ",
            endTime: "End Time: ",
            startDate: "Start Date: ",
            endDate: "end Date: ",
            allLevelsWelcome: "All Levels Welcome",
            beginner: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
            eventType: "Event Type: ",
            family: "Family",
            babyAndToddlers: "Baby and Toddlers",
            musicAndDance: "Music and Dance",
            conversationGroup: "Conversation Group",
            artsAndCrafts: "Arts and Crafts",
            talkLecture: "Talk/Lecture",
            universityEvent: "University Event",
            Session: "Session",
            pubNight: "Pub Night",
            religious: "Religious",
            meeting: "Meeting",
            CoffeeMorning: "Coffee Morning",
            ageBracket: "Age Bracket: ",
            preSchoolChildren: "Pre-School Children",
            schoolAgedChildren: "School Aged Child",
            teenagers: "Teenagers",
            adults: "Adults",
            allAgesWelcome: "All Ages Welcome",
            language: "Language: ",
            gaelicOnly: "Gaelic Only",
            gaelicAndEnglish: "Gaelic and English",
            createEvent: "Create Event",
            cancel: "Cancel",
        },

        gd: {
            endTimeBefore: "An t-àm crìochnachaidh ron àm tòiseachaidh",
            startTimePassed: "An t-àm tòiseachaidh air a dhol seachad",
            endDateBefore: "An ceann-latha crìochnachaidh ron cheann-latha tòiseachaidh",
            startDatePast: "Ceann-latha tòiseachaidh seachad",
            invalidPostcodeEntered: "Còd-puist mì-dhligheach",
            yourFormCannotBeSubmitted: "Cha ghabh an fhoirm agad a chur a-steach:",
            addAnEvent: "Cuir ris Tachartas",
            eventTitle: "Tiotal an Tachartais",
            eventDescription: "Tuairisgeul an Tachartais (ma tha tiogaidean a dhìth, cuir ceangal gu àite nan tiogaidean) ",
            eventStartTime: "Àm Tòiseachaidh an Tachartais",
            eventEndTime: "Àm Crìochnachaidh an Tachartais",
            eventStartDate: "Ceann-latha Tòiseachaidh an Tachartais",
            eventEndDate: "Ceann-latha Crìochnachaidh an Tachartais",
            eventPostcode: "Còd-puist an Tachartais",
            uploadImage: "Luchdaich Suas Ìomhaigh",
            eventProficiencyLevel: "Ìre Comais an Tachartais ",
            createEvent: "Cruthaich Tachartas",
            startTime: "Àm tòiseachaidh: ",
            endTime: "Àm crìochnachaidh: ",
            startDate: "Ceann-latha tòiseachaidh: ",
            endDate: "Ceann-latha crìochnachaidh: ",
            allLevelsWelcome: "Gach Ìre Di-beathte",
            beginner: "Neach-tòiseachaidh",
            intermediate: "Eadar-mheadhanach",
            advanced: "Adhartach",
            eventType: "Seòrsa Tachartais: ",
            family: "Teaghlach",
            babyAndToddlers: "Leanabh is Pàistean",
            musicAndDance: "Ceòl is Dannsa",
            conversationGroup: "Buidheann Còmhraidh",
            artsAndCrafts: "Ealain is Ciùird",
            talkLecture: "Còmhradh / Òraid",
            universityEvent: "Tachartas Oilthighe",
            Session: "Seisean",
            pubNight: "Oidhche Taigh-seinnse",
            religious: "Cràbhach",
            meeting: "Coinneamh",
            CoffeeMorning: "Madainn Cofaidh",
            ageBracket: "Raon aoise: ",
            preSchoolChildren: "Clànn Fo-sgoile",
            choolAgedChildren: "Clann Aois-sgoile ",
            teenagers: "Deugairean",
            adults: "Inbhich",
            allAgesWelcome: "Gach Aois Di-beathte",
            language: "Cànan: ",
            gaelicOnly: "Gàidhlig a-mhàin",
            gaelicAndEnglish: "Gàidhlig agus Beurla",
            createEvent: "Cruthaich Tachartas",
            cancel: "Dubh às",
            
        },
    };

    const [imageFile, setImageFile] = useState(null);

    const [formData, setFormData] = useState({
        event_title: "", 
        description: "",
        start_time: new Date(Math.round((current_date.getTime() + 60*60*1000)/ (60 * 60 * 1000)) * (60 * 60 * 1000)).toLocaleTimeString(), 
        end_time: new Date(Math.round((current_date.getTime() + 120*60*1000)/ (60 * 60 * 1000)) * (60 * 60 * 1000)).toLocaleTimeString(), //one hour later than start time

        start_date: current_date.getFullYear().toString() + '-' + 
                    (current_date.getMonth() + 1).toString().padStart(2, 0) + '-' + 
                    current_date.getDate().toString().padStart(2, 0),      //todays date formatted to display in form

        end_date: current_date.getFullYear().toString() + '-' + 
                  (current_date.getMonth() + 1).toString().padStart(2, 0) + '-' + 
                   current_date.getDate().toString().padStart(2, 0),      //todays date formatted to display in form

        postcode: "",
        event_picture: "",
        event_proficiency: "all levels",
        event_type: [],    
        age_bracket: "all ages welcome",
        language: "gaelic and english",
    });

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        console.log(name);
        console.log(value);
        setFormData({ ...formData, [name]: value});
    };

    const handleEventTypeChange = (e) => {
        const {name, value} = e.target;
        let currentEventType = formData.event_type;
        (currentEventType.includes(value) ? currentEventType.splice(currentEventType.indexOf(value), 1) : currentEventType.push(value) );
        setFormData({ ...formData, [name]: currentEventType});
    };

    function checkNumeric(code) {
        return !isNaN(parseInt(code, 10))
    }


    const handleEventSubmit = async (e) => {
        e.preventDefault();
        fetchEvents();

        //form validation 
        const errorDisplay = document.getElementById("event-error")
        var today = current_date.getFullYear().toString() + '-' + (current_date.getMonth() + 1).toString().padStart(2, 0) +
             '-' + current_date.getDate().toString().padStart(2, 0);
        var time_now = new Date().toLocaleTimeString();
        console.log(time_now);
        let errors = []

        //clear any existing errors - may have been fixed 
        document.getElementById("start-date-error").textContent = '';
        document.getElementById("end-date-error").textContent = '';
        document.getElementById("start-time-error").textContent = '';
        document.getElementById("end-time-error").textContent = '';
        document.getElementById("postcode-error").textContent = '';
        errorDisplay.innerHTML = '';

        //check end time is not before start time and start time is not before current time if start date is today
        if (formData.end_time < formData.start_time){
            errors.push(`${translations[language].endTimeBefore}`);
            document.getElementById("end-time-error").textContent = 'End time is before start time';
        }

        if (formData.start_date === today){
            if (formData.start_time < time_now){
                errors.push(`${translations[language].startTimePassed}`);
                document.getElementById("start-time-error").textContent = 'Start time has passed';
            }
        }


        //check end date is not before start date and start date is in the future
        if (formData.end_date < formData.start_date){
            errors.push(`${translations[language].endDateBefore}`);
            document.getElementById("end-date-error").textContent = 'End date is before start date.';
        }
      
        if (formData.start_date < today){
            errors.push(`${translations[language].startDatePast}`);
            document.getElementById("start-date-error").textContent = 'Start date has passed';
        }


        //check postcode syntax is valid and postcode is in Scotland
        const valid_areas = ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'TD', 'ZE']
        const area_code = formData.postcode.substring(0,2);

        if (formData.postcode.length < 5 || formData.postcode.length > 8){
            errors.push('Invalid postcode entered');
            document.getElementById("postcode-error").textContent = 'Invalid postcode entered'
        }else if (! valid_areas.includes(area_code.toUpperCase())){
            //consider edge case where area code is G[0-9]
            if (! (area_code.substring(0,1).toUpperCase() === 'G' && checkNumeric(area_code.substring(1,2)))){
                errors.push('Invalid postcode entered');
                document.getElementById("postcode-error").textContent = 'Invalid postcode entered'
            }
        }
        
        if (errors.length > 0){
            errorDisplay.innerText = 'Your form cannot be submitted: ';
            
        }else{

            onClose();
            retrieveLatLong(formData, imageFile);

        }
    };


    const handleImageChange = async(e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            handleInputChange(e);
        }else{
            setImageFile(null);
            handleInputChange(e);
        }
    }

    

    return (
        
    

        <div className="create-event">
            <div className="event-form-header">
                <h4 className="form-title"> {translations[language].addAnEvent}</h4>
                <button className= "close-x" onClick={onClose}>&times;</button> 
            </div>


            <form id="event-form" onSubmit={handleEventSubmit}>

            <div className="text-center text-danger" id="event-error"></div>
            
            <div className="form-group mb-3">
                <input 
                    className="form-input form-control text-center"
                    type="text"
                    name="event_title"
                    id="event_title"
                    value={formData.event_title}
                    onChange={handleInputChange}
                    placeholder={translations[language].eventTitle}
                    required
                />
            </div>
            
            <div className="form-group mb-3">
                <textarea
                    className="form-input form-control text-center"
                    id = "event-description"
                    rows="3"
                    type="textarea"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder={translations[language].eventDescription}
                    required
                />
            </div>
            
            <div className="grid-container">
                <div className="row">

                    <div className="form-group w-50">
                        <label for="start-time">{translations[language].startTime}</label>
                        <input
                            className="form-input"
                            type="time"
                            id="start-time"
                            name="start_time"
                            value={formData.start_time}
                            onChange={handleInputChange}
                            placeholder={translations[language].eventStartTime}
                            required
                        />

                        <small className="error-message" id="start-time-error"></small>
                    </div>

                    <div className="form-group w-50">
                        <label for="end-time">{translations[language].endTime}</label>

                        <input
                            className="form-input"
                            type="time"
                            name="end_time"
                            value={formData.end_time}
                            onChange={handleInputChange}
                            placeholder={translations[language].eventEndTime}
                            required
                        />

                        <small className="error-message" id="end-time-error"></small>
                    </div>
    
                </div>
            </div>

           

            <div className="grid-container">
                <div className="row">

                    <div className="form-group w-50">
                        <label for="start-date">{translations[language].startDate} </label>
                        <input
                            className="form-input"
                            id="start-date"
                            type="date"
                            name="start_date"
                            value={formData.start_date}
                            onChange={handleInputChange}
                            placeholder={translations[language].eventStartDate}
                            required
                        />
                        <small className="error-message" id="start-date-error"></small>
                    </div>

                    <div className="form-group w-50 mb-3">

                        <label for="end-date">{translations[language].endDate}</label>
                        <input
                            className="form-input"
                            id="end-date"
                            type="date"
                            name="end_date"
                            value={formData.end_date}
                            onChange={handleInputChange}
                            placeholder={translations[language].eventEndDate}
                            required
                        />
                        <small className="error-message" id="end-date-error"></small> 
                    </div>
                </div>
            </div>


            <div className="form-group mb-2">
                <input
                    className="form-input form-control text-center"
                    type="text"
                    name="postcode"
                    value={formData.postcode}
                    onChange={handleInputChange}
                    placeholder={translations[language].eventPostcode}
                    required
                />
                <small className="error-message" id="postcode-error"></small>
            </div>


            <div className="event-media-input mb-3">
                <label className="upload-file" for="img-input">{translations[language].uploadImage}</label>
                <input
                    type="file"
                    id = "img-input"
                    name="event_picture"
                    value={formData.event_picture}
                    onChange={handleImageChange}
                    accept="image/*"
                />
            </div>
            

            <div className="form-group mb-3">
                <label>{translations[language].eventProficiencyLevel} </label>
                <select 
                    className="form-input form-control text-center"
                    name="event_proficiency"
                    value={formData.event_proficieny}
                    onChange={handleInputChange}
                >
                    <option value="all_levels">{translations[language].allLevelsWelcome}</option>
                    <option value="beginner">{translations[language].beginner}</option>
                    <option value="intermediate">{translations[language].intermediate}</option>
                    <option value="advanced">{translations[language].advanced}</option>
                </select>
            </div>

            
            <div className="form-group mb-3">
                <label>{translations[language].eventType}</label>
                <select 
                    className="form-input form-control text-center"
                    multiple
                    name="event_type"
                    value={formData.event_type}
                    onChange={handleEventTypeChange}
                >
                    <option value="family">{translations[language].family}</option>
                    <option value="baby and toddlers">{translations[language].babyAndToddlers}</option>
                    <option value="music and dance">{translations[language].musicAndDance}</option>
                    <option value="conversation group">{translations[language].conversationGroup}</option>
                    <option value="arts and crafts">{translations[language].artsAndCrafts}</option>
                    <option value="talk/lecture">{translations[language].talkLecture}</option>
                    <option value="university event">{translations[language].universityEvent}</option>
                    <option value="session">{translations[language].Session}</option>
                    <option value="pub night">{translations[language].pubNight}</option>
                    <option value="religious">{translations[language].religious}</option>
                    <option value="meeting">{translations[language].meeting}</option>
                    <option value="coffee morning">{translations[language].CoffeeMorning}</option>
                </select>
            </div>


            <div className="form-group mb-3">
                <label>{translations[language].ageBracket}</label>
                <select 
                    className="form-input form-control text-center"
                    name="age_bracket"
                    value={formData.age_bracket}
                    onChange={handleInputChange}
                >
                    <option value="pre-school children">{translations[language].preSchoolChildren}</option>
                    <option value="school-aged children">{translations[language].schoolAgedChildren}</option>
                    <option value="teenagers">{translations[language].teenagers}</option>
                    <option value="adults">{translations[language].adults}</option>
                    <option value="all ages welcome">{translations[language].allAgesWelcome}</option>
                </select>
            </div>

            <div className="form-group mb-4">
                <label>{translations[language].language}</label>
                <select 
                    className="form-input form-control text-center"
                    name="language"
                    value={formData.language}
                    onChange={handleInputChange}
                >
                    <option value="gaelic only">{translations[language].gaelicOnly}</option>
                    <option value="gaelic and english">{translations[language].gaelicAndEnglish}</option>
                </select>
            </div>

            <button type="submit" className="btn btn-primary form-action-button">{translations[language].createEvent}</button>
            <button type = "button" className="btn btn-danger form-action-button ms-2" onClick = {onClose}>{translations[language].cancel}</button>
            </form>
        </div>
        

    );
}
    
export default EventForm